<template>
  <div class="container dcops-move-page">
    <div class="title">
      <el-breadcrumb>
        <el-breadcrumb-item>业务管理</el-breadcrumb-item>
        <el-breadcrumb-item>工单管理</el-breadcrumb-item>
        <el-breadcrumb-item>Dcops工单</el-breadcrumb-item>
        <el-breadcrumb-item>服务器搬迁</el-breadcrumb-item>
      </el-breadcrumb>
    </div>


    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="建单时间">
                <el-date-picker v-model="searchForm.create_time" type="daterange" range-separator="-"
                  style="width: 100%" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                  @change="handleDateChange">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <!-- 超时时间 -->
            <el-col :span="6">
              <el-form-item label="超时时间">
                <el-date-picker v-model="searchForm.olaTime" type="daterange" range-separator="-" style="width: 100%"
                  start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                  @change="handleOlaTimeChange">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <!-- 工单ID -->
            <el-col :span="6">
              <el-form-item label="工单ID">
                <el-input v-model="searchForm.TicketId" placeholder="请输入工单ID"></el-input>
              </el-form-item>
            </el-col>
            <!-- 时效 -->
            <el-col :span="6">
              <el-form-item label="时效">
                <el-select clearable v-model="searchForm.rd_olaTime" placeholder="请选择时效">
                  <el-option label="预超时" value="1"></el-option>
                  <el-option label="超时-进行中" value="2"></el-option>
                  <el-option label="超时-完成" value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="区域-园区">
                <el-select clearable v-model="searchForm.Campus" placeholder="请选择" @focus="handleSelectFocus">
                  <el-option v-for="item in campusOptions" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 场景 -->
            <el-col :span="6">
              <el-form-item label="场景">
                <el-select clearable v-model="searchForm.Scene" placeholder="请选择场景">
                  <el-option label="搬入" value="搬入"></el-option>
                  <el-option label="搬出" value="搬出"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 状态 -->
            <el-col :span="6">
              <el-form-item label="状态">
                <el-select clearable v-model="searchForm.state" placeholder="请选择状态">
                  <el-option label="完成" value="完成"></el-option>
                  <el-option label="进行中" value="进行中"></el-option>
                  <el-option label="驳回" value="驳回"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="search-button">
                <el-button type="primary" @click="handleSearch">点击查询</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <div class="title-en">服务器搬迁列表</div>
    <el-card class="box-card">
      <div class="table-container">
        <div class="button-container">
          <el-button type="success" plain :loading="syncLoading" :disabled="syncLoading" @click="UpdateServerMoveListBtn">更新服务器列表</el-button>
          <el-button @click="openColumnsDialog">表头设置</el-button>
        </div>
        <el-table :data="showData" border stripe @selection-change="handleSelectionChange" ref="table"
          v-loading="loading">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column v-for="(column, index) in visibleColumns" :key="index" :prop="column.prop"
            :label="column.label" :width="column.width" :align="column.align" :fixed="column.fixed">
            <template slot-scope="scope">
              <!-- TaskList：渲染迷你表格 -->
              <div v-if="column.prop === 'TaskList'" class="tasklist-cell">
                <table v-if="normalizedTaskList(scope.row.TaskList, scope.row.Scene).length" class="tasklist-mini">
                  <thead>
                    <tr>
                      <th style="width: 40px">任务</th>
                      <th style="width: 90px">时间</th>
                      <th style="width: 120px">接单人</th>
                      <th style="width: 120px">结单人</th>
                      <th style="width: 80px">状态</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(t, tIndex) in normalizedTaskList(scope.row.TaskList, scope.row.Scene)" :key="tIndex">
                      <td class="tasklist-step">{{ t.label || t.key || '-' }}</td>
                      <td class="tasklist-time">
                        <div class="tasklist-time-wrap">
                          <div class="tasklist-time-row">
                            <span class="tasklist-time-dot" />
                            <span>{{ formatTaskTime(t.beginTime) }}</span>
                          </div>
                          <div class="tasklist-time-row">
                            <span class="tasklist-time-line" />
                            <span>{{ formatTaskTime(t.endTime) }}</span>
                          </div>
                        </div>
                      </td>
                      <td class="tasklist-operator">{{ t.operator || '-' }}</td>
                      <td class="tasklist-operator">{{ t.realOperator || '-' }}</td>
                      <td class="tasklist-status">
                        <el-tooltip :content="t.status || '未知'" placement="top">
                          <span class="tasklist-status-wrap">
                            <i :class="taskStatusIcon(t.status)" />
                            <span class="tasklist-status-text">{{ t.status || '-' }}</span>
                          </span>
                        </el-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <span v-else class="tasklist-empty">-</span>
              </div>

              <!-- 其它列：使用默认文本渲染 -->
              <span v-else>{{ formatCell(scope.row, column.prop) }}</span>
            </template>
          </el-table-column>
        </el-table>

        <!-- 月份选择对话框 -->
        <el-dialog title="选择月份范围" :visible.sync="monthSelectDialogVisible" :append-to-body="true" width="700px"
          :close-on-click-modal="false" custom-class="month-select-dialog" :modal-append-to-body="false"
          :destroy-on-close="true">
          <el-form :model="monthSelectForm" label-width="100px">
            <el-form-item label="开始月份">
              <el-date-picker v-model="monthSelectForm.startMonth" type="month" placeholder="选择开始月份" format="yyyy-MM"
                value-format="yyyy-MM" style="width: 100%">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束月份">
              <el-date-picker v-model="monthSelectForm.endMonth" type="month" placeholder="选择结束月份" format="yyyy-MM"
                value-format="yyyy-MM" style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="monthSelectDialogVisible = false">取消</el-button>
            <el-button type="primary" :loading="syncLoading" :disabled="syncLoading" @click="confirmMonthSelect">确定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="设置显示项" :visible.sync="showColumnsDialog" :append-to-body="true" width="400px"
          :close-on-click-modal="false" custom-class="columns-dialog" :modal-append-to-body="false"
          :destroy-on-close="true">
          <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
            <el-checkbox v-for="column in columns" :key="column.prop" :label="column.prop" class="checkbox-item">
              {{ column.label }}
            </el-checkbox>
          </el-checkbox-group>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="selectAllColumns">全选</el-button>
            <el-button size="small" @click="restoreDefaultColumns">恢复默认</el-button>
            <el-button size="small" type="primary" @click="saveColumnsDialog">保存</el-button>
          </div>
        </el-dialog>

        <div class="pagination-container">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getDcopsMoveCampusOptions } from '@/api/analysis';
import { getServerMoveList, UpdateServerMoveList } from '@/api/dcopsTicket';
import dcopsTicketSyncLoading from '@/mixins/dcopsTicketSyncLoading';
import { debounce } from 'lodash';
import * as XLSX from 'xlsx';
export default {
  name: 'FaultList',
  mixins: [dcopsTicketSyncLoading],
  data() {
    return {
      dcopsSyncKey: 'move',
      tabPosition: 1,
      showColumnsDialog: false,
      // 月份选择对话框相关
      monthSelectDialogVisible: false,
      monthSelectForm: {
        startMonth: this.$moment().subtract(1, 'month').format('YYYY-MM'), // 默认上个月
        endMonth: this.$moment().format('YYYY-MM') // 默认当前月份
      },
      campusOptions: [], // 用于存储园区接口返回的数据
      hasLoaded: false, // 添加标志位防止重复加载
      // 服务器搬迁（DCOPS工单）字段
      columns: [
        { prop: 'TicketId', label: 'dcops单号', width: 160 },
        { prop: 'ProcessTitle', label: '工单标题', width: 220 },
        { prop: 'TaskList', label: '任务列表', width: 600 },
        { prop: 'Scene', label: '场景', width: 90 },
        { prop: 'OlaTime', label: '超时时间', width: 160 },
        { prop: 'Campus', label: '园区', width: 120 },
        { prop: 'InstanceStatus', label: '流程状态', width: 110 },
        { prop: 'CreateTime', label: '流程开始时间', width: 160 },
        { prop: 'EndTime', label: '流程结束时间', width: 160 },
        { prop: 'Amount', label: '每单台数', width: 90 },
        { prop: 'IdcpName', label: '一级机房', width: 140 },
        { prop: 'UpdownPOTicketId', label: '上下架PO单信息', width: 160 },
        { prop: 'LinePOTicketId', label: '接线PO单信息', width: 160 },
        { prop: 'IsAI', label: '是否AI搬迁', width: 110 },

      ],
      selectedColumns: [
        'TicketId',
        'ProcessTitle',
        'TaskList',
        'Scene',
        'Amount',
        'IdcpName',
        'Campus',
        'InstanceStatus',
        'CreateTime',
        'EndTime',
        'OlaTime',
        'UpdownPOTicketId',
        'LinePOTicketId',
        'IsAI',
      ],
      defaultSelectedColumns: [
        'TicketId',
        'ProcessTitle',
        'TaskList',
        'Scene',
        'Amount',
        'IdcpName',
        'Campus',
        'InstanceStatus',
        'CreateTime',
        'EndTime',
        'OlaTime',
        'UpdownPOTicketId',
        'LinePOTicketId',
        'IsAI',
      ],
      visibleColumns: [],
      selectedRows: [],
      showData: [],
      searchForm: {
        create_time: [],
        start_time: '',
        end_time: '',
        TicketId: '',
        Campus: '',
        Scene: '', // 添加场景搜索字段
        state: '', // 添加状态搜索字段
        olaStartTime: '',
        olaEndTime: '',
        rd_olaTime: '',
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      exportLoading: false,
    };
  },
  created() {
    const now = new Date();
    const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
    const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    this.searchForm.create_time = [
      this.$moment(startDate).format('YYYY-MM-DD'),
      this.$moment(endDate).format('YYYY-MM-DD'),
    ];
    this.handleDateChange(this.searchForm.create_time);
    this.handleOlaTimeChange([this.searchForm.olaStartTime, this.searchForm.olaEndTime]);
    this.visibleColumns = this.columns.filter((column) =>
      this.selectedColumns.includes(column.prop)
    );
    this.serverMoveData();
    this.getCampusData();
    // 创建防抖后的导出函数
    this.debouncedExport = debounce(this.handleExport, 300);
  },
  methods: {
    onDcopsSyncFinished() {
      this.serverMoveData();
    },
    // 更新服务器列表按钮点击事件
    UpdateServerMoveListBtn() {
      if (!this.ensureDcopsSyncNotRunning()) return;
      this.monthSelectDialogVisible = true;
    },

    // 确认月份选择
    confirmMonthSelect() {
      if (!this.ensureDcopsSyncNotRunning()) return;
      if (!this.monthSelectForm.startMonth || !this.monthSelectForm.endMonth) {
        this.$message.warning('请选择开始月份和结束月份');
        return;
      }

      // 验证结束月份不能早于开始月份
      const start = this.$moment(this.monthSelectForm.startMonth, 'YYYY-MM');
      const end = this.$moment(this.monthSelectForm.endMonth, 'YYYY-MM');
      if (end.isBefore(start)) {
        this.$message.warning('结束月份不能早于开始月份');
        return;
      }

      this.monthSelectDialogVisible = false;

      // 调用 UpdateServerMoveList API
      const params = {
        start_month: this.monthSelectForm.startMonth,
        end_month: this.monthSelectForm.endMonth
      };

      UpdateServerMoveList(params)
        .then((res) => {
          this.handleDcopsSyncResponse(res, () => {
            this.serverMoveData();
          });
        })
        .catch((err) => {
          console.error('更新服务器列表失败:', err);
          this.$message.error('更新服务器列表失败');
        });
    },

    //园区获取数据接口
    async getCampusData() {
      try {
        const response = await getDcopsMoveCampusOptions();
        if (response.data && response.data.code === 200) {
          const raw = (response.data.data && response.data.data.campus_list) || [];
          // 二次去重兜底，避免历史脏数据重复
          this.campusOptions = Array.from(new Set(raw.filter(Boolean)));
          this.hasLoaded = true;
        } else {
          console.warn("接口返回状态码不正确:", response.data?.code)
        }
      } catch (error) {
        console.error('获取园区数据失败:', error);
      }
    },
    // focus 事件处理园区获取数据
    handleSelectFocus() {
      if (!this.hasLoaded) {
        this.getCampusData();
      }
    },
    handleOlaTimeChange(val) {
      // el-date-picker 清空时可能传 []（truthy），需要按长度判断
      if (Array.isArray(val) && val.length === 2 && val[0] && val[1]) {
        this.searchForm.olaStartTime = val[0];
        this.searchForm.olaEndTime = val[1] + ' 23:59:59';
      } else {
        // 置空时不要传空字符串给后端（Pydantic 会报 input too short）
        this.searchForm.olaStartTime = null;
        this.searchForm.olaEndTime = null;
      }
    },
    handleDateChange(val) {
      // el-date-picker 清空时可能传 []（truthy），需要按长度判断
      if (Array.isArray(val) && val.length === 2 && val[0] && val[1]) {
        this.searchForm.start_time = val[0];
        this.searchForm.end_time = val[1] + ' 23:59:59';
      } else {
        // 置空时不要传空字符串给后端（Pydantic 会报 input too short）
        this.searchForm.start_time = null;
        this.searchForm.end_time = null;
      }
    },
    serverMoveData() {
      this.loading = true;
      const rawParams = {
        page: this.currentPage,
        size: this.pageSize,
        ...this.searchForm,
      };
      delete rawParams.create_time;
      // 过滤掉空值，避免把 "" / [] 传给后端导致 datetime 校验报错
      const params = Object.fromEntries(
        Object.entries(rawParams).filter(([, value]) => {
          if (value === '' || value === null || value === undefined) return false;
          if (Array.isArray(value) && value.length === 0) return false;
          return true;
        })
      );
      getServerMoveList(params)
        .then((res) => {
          if (res.data.code === 200) {
            console.log(res.data);
            this.showData = res.data.data.data || [];
            this.total = res.data.data.total || 0;
          } else {
            this.$message.error(res.msg || '获取列表失败');
          }
          this.loading = false;
        })
        .catch((err) => {
          console.error('获取列表失败:', err);
          this.$message.error('获取列表失败');
          this.loading = false;
        });
    },
    normalizedTaskList(taskList, scene) {
      if (!taskList) return [];

      // tem.json: TaskList 是 JSON 字符串，解析后是数组：[{Updown:{...}}, {Line:{...}}, ...]
      let parsed = taskList;
      if (typeof taskList === 'string') {
        const s = taskList.trim();
        if (!s) return [];
        try {
          parsed = JSON.parse(s);
        } catch (e) {
          return [];
        }
      }

      // 把 [{Updown:{...}}, {Line:{...}}] 合并成 {Updown:{...}, Line:{...}}
      const merged = {};
      if (Array.isArray(parsed)) {
        parsed.forEach((item) => {
          if (item && typeof item === 'object') {
            Object.entries(item).forEach(([k, v]) => {
              merged[k] = v;
            });
          }
        });
      } else if (parsed && typeof parsed === 'object') {
        Object.assign(merged, parsed);
      }

      const order = ['Updown', 'Line', 'Follow', 'Outin'];
      const result = [];

      order.forEach((key) => {
        const v = merged[key];
        if (!v || typeof v !== 'object') return;

        const beginTime = (v.BeginTime || '').toString().trim();
        const endTime = (v.EndTime || '').toString().trim();
        const operator = (v.Operator || '').toString().trim();
        const realOperator = (v.RealOperator || '').toString().trim();
        const status = (v.TaskStatus || '').toString().trim();

        // 全空就不展示这一行
        if (!beginTime && !endTime && !operator && !realOperator && !status) return;

        result.push({
          key,
          label: this.taskStepLabel(key, scene),
          beginTime: beginTime || null,
          endTime: endTime || null,
          operator: operator || null,
          realOperator: realOperator || null,
          status: status || null,
        });
      });

      return result;
    },
    taskStepLabel(key, scene) {
      const s = (scene || '').toString();
      if (key === 'Updown') return s.includes('搬出') ? '下架' : '上架';
      if (key === 'Line') return s.includes('搬出') ? '拔线' : '接线';
      if (key === 'Outin') return s.includes('搬出') ? '出库' : '入库';
      if (key === 'Follow') return '随工';
      return key;
    },
    formatTaskTime(val) {
      if (!val) return '-';
      const s = String(val).trim();
      if (!s) return '-';
      const m = this.$moment(s);
      return m.isValid() ? m.format('MM-DD HH:mm') : String(val);
    },
    taskStatusIcon(status) {
      const s = (status || '').toString();
      // 兼容：进行中/完成/驳回/待处理 等
      if (/(完成|已完成|success|done|finish)/i.test(s)) return 'el-icon-circle-check task-icon--success';
      if (/(驳回|拒绝|失败|error|fail|reject)/i.test(s)) return 'el-icon-circle-close task-icon--danger';
      if (/(进行中|处理中|processing|running|in_progress)/i.test(s))
        return 'el-icon-loading task-icon--running';
      if (/(待处理|待开始|pending|todo|wait)/i.test(s)) return 'el-icon-time task-icon--pending';
      return 'el-icon-info task-icon--unknown';
    },
    formatCell(row, prop) {
      const v = row ? row[prop] : undefined;
      if (v === '' || v === null || v === undefined) return '-';
      if (prop === 'IsAI') return String(v) === '1' ? '是' : '否';
      if (['CreateTime', 'EndTime', 'OlaTime'].includes(prop)) {
        const m = this.$moment(v);
        return m.isValid() ? m.format('YYYY-MM-DD HH:mm:ss') : String(v);
      }
      return String(v);
    },
    handleSearch() {
      this.currentPage = 1;
      this.serverMoveData();
    },
    handleReset() {
      this.searchForm = {
        create_time: [],
        start_time: null,
        end_time: null,
        olaStartTime: null,
        olaEndTime: null,
        TicketId: '',
        Campus: '',
        Scene: '', // 重置场景字段
        state: '', // 重置状态字段
        rd_olaTime: '',
      };
      this.handleOlaTimeChange(null);
      this.handleDateChange(this.searchForm.create_time);

      this.tabPosition = '1';
      this.currentPage = 1;
      this.serverMoveData();
    },
    async handleExport() {
      if (this.exportLoading) return;
      this.exportLoading = true;
      this.loading = true;

      try {
        if (this.selectedRows.length === 0) {
          // 导出全部数据
          const params = {
            category_level: Number(this.tabPosition),
            export_excel: '1',
            ...Object.fromEntries(
              Object.entries(this.searchForm).filter(
                ([key, value]) =>
                  value !== '' && value !== null && value !== undefined && key !== 'create_time'
              )
            ),
          };

          const response = await getServerMoveList(params);

          if (response.data) {
            // 兼容不同接口返回结构：列表接口用 data.data.data
            const allData = response.data?.data?.data || response.data?.data?.list || [];
            // 转换数据格式
            const worksheetData = allData.map((row) => {
              const rowData = {};
              this.columns.forEach((column) => {
                if (column.prop !== 'operation') {
                  let value = row[column.prop];
                  if (['CreateTime', 'EndTime', 'OlaTime'].includes(column.prop) && value) {
                    value = this.$moment(value).format('YYYY-MM-DD HH:mm:ss');
                  } else if (column.prop === 'IsAI' && value !== null && value !== undefined) {
                    value = String(value) === '1' ? '是' : '否';
                  }
                  rowData[column.label] = value || '-';
                }
              });
              return rowData;
            });

            // 创建工作簿和工作表
            const worksheet = XLSX.utils.json_to_sheet(worksheetData);

            // 设置列宽
            const colWidths = {};
            this.visibleColumns.forEach((column, index) => {
              const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
              colWidths[XLSX.utils.encode_col(index)] = { wch: width };
            });
            worksheet['!cols'] = Object.values(colWidths);

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, '服务器搬迁列表');

            // 生成文件名
            const timestamp = this.$moment().format('YYYYMMDDHHmmss');
            const filename = `服务器搬迁列表_${timestamp}.xlsx`;

            // 导出文件
            XLSX.writeFile(workbook, filename);
            this.$message.success('导出成功');
          }
        } else {
          // 导出选中数据
          if (this.selectedRows.length === 0) {
            this.$message.warning('没有数据可导出');
            return;
          }

          const worksheetData = this.selectedRows.map((row) => {
            const rowData = {};
            this.columns.forEach((column) => {
              if (column.prop !== 'operation') {
                let value = row[column.prop];
                if (['CreateTime', 'EndTime', 'OlaTime'].includes(column.prop) && value) {
                  value = this.$moment(value).format('YYYY-MM-DD HH:mm:ss');
                } else if (column.prop === 'IsAI' && value !== null && value !== undefined) {
                  value = String(value) === '1' ? '是' : '否';
                }
                rowData[column.label] = value || '-';
              }
            });
            return rowData;
          });

          const worksheet = XLSX.utils.json_to_sheet(worksheetData);

          const colWidths = {};
          this.visibleColumns.forEach((column, index) => {
            const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
            colWidths[XLSX.utils.encode_col(index)] = { wch: width };
          });
          worksheet['!cols'] = Object.values(colWidths);

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, '服务器搬迁列表');

          const timestamp = this.$moment().format('YYYYMMDDHHmmss');
          const filename = `服务器搬迁列表_${timestamp}.xlsx`;

          XLSX.writeFile(workbook, filename);
          this.$message.success('导出成功');
        }
      } catch (error) {
        console.error('导出错误:', error);
        this.$message.error('导出失败，请重试');
      } finally {
        this.exportLoading = false;
        this.loading = false;
      }
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
      this.visibleColumns = this.columns.filter((column) =>
        this.selectedColumns.includes(column.prop)
      );
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((column) => column.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.serverMoveData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.serverMoveData();
    },
    handleTabChange() {
      this.currentPage = 1;
      this.serverMoveData();
    },
    handleViewDetail(row) {
      window.open(
        `https://dcops.fre.tencent-cloud.com/appManage/tickets/details?params=${row.TicketId || row.ticketId || ''}`,
        '_blank'
      );
    },
  },
  computed: {
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
  },
};
</script>

<style scoped>
.container {
  padding: 20px;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}

.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.search-form {
  width: 100%;
}

.search-button {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 10px;
}

/* 调整表单项间距 */
.el-form-item {
  margin-bottom: 18px;
  display: flex;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.box-card {
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
}

.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}

.columns-dialog {
  margin-top: 0 !important;
  position: absolute !important;
  margin-left: 0 !important;
  top: 100% !important;
  left: 0 !important;
  transform: none !important;
}

.el-dialog__wrapper.columns-dialog {
  position: absolute !important;
  overflow: visible !important;
}

.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.checkbox-item {
  margin-right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid var(--dm-dialog-footer-border, #ebeef5);
}

.dialog-footer .el-button+.el-button {
  margin-left: 8px;
}

/* TaskList 迷你表格 */
.tasklist-cell {
  line-height: 1.2;
}

.tasklist-mini {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.tasklist-mini th,
.tasklist-mini td {
  border: 1px solid #ebeef5;
  padding: 4px 6px;
  vertical-align: top;
}

.tasklist-mini thead th {
  background: #fafafa;
  color: #606266;
  font-weight: 600;
}

.tasklist-step {
  color: #303133;
  font-weight: 600;
}

.tasklist-time {
  color: #606266;
  white-space: nowrap;
}

.tasklist-time-wrap {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.tasklist-time-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.tasklist-time-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  /* 开始时间：绿色 */
  background: #67c23a;
  flex: 0 0 auto;
}

.tasklist-time-line {
  width: 6px;
  height: 6px;
  border-radius: 2px;
  /* 结束时间：红色 */
  background: #f56c6c;
  flex: 0 0 auto;
}

.tasklist-operator {
  color: #606266;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tasklist-status {
  text-align: center;
}

.tasklist-status-wrap {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.tasklist-status-text {
  color: #606266;
  font-size: 12px;
}

.tasklist-empty {
  color: #c0c4cc;
}

.task-icon--success {
  color: #67c23a;
}

.task-icon--danger {
  color: #f56c6c;
}

.task-icon--running {
  color: #409eff;
}

.task-icon--pending {
  color: #e6a23c;
}

.task-icon--unknown {
  color: #909399;
}

/* PO单号链接样式 */
::v-deep .el-table a {
  color: #409eff;
  text-decoration: none;
  font-weight: 500;
}

::v-deep .el-table a:hover {
  color: #66b1ff;
  text-decoration: underline;
  font-weight: 500;
}

/* 修改日期选择器宽度 */
::v-deep .el-date-editor.el-input__inner,
.el-date-editor--daterange.el-input__inner {
  width: 100% !important;
}

::v-deep .el-range-editor.el-input__inner {
  width: 100% !important;
}

::v-deep .el-date-editor .el-range-input {
  width: 66% !important;
}

::v-deep .el-range-editor--small .el-range-input {
  font-size: 12px !important;
}

/* 统一下拉框和输入框宽度 */
::v-deep .el-select,
.el-input {
  width: 100% !important;
}

::v-deep .el-form-item__content {
  width: calc(100% - 10px) !important;
}
</style>